import React, { useEffect } from 'react';

export default function LogoutHelper() {
  const getParentDomain = (url) => {
    const domain = url
      .replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
      .split('/')[0];
    const parts = domain.split('.');
    if (parts.length <= 2) {
      return domain;
    }
    return parts.slice(-2).join('.');
  };

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(';').forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Domain=.${getParentDomain(
        window.location.origin
      )}`;
    });

    // Notify parent
    window.parent.postMessage('logout-complete', '*');
  }, []);

  return <div>Logging out...</div>;
}
